import React from 'react'
import styled from '@emotion/styled'
import { Link } from 'gatsby'

const List = styled.ul`
  display: inline-block;
`

const Tag = styled.li`
  vertical-align: bottom;
  display: inline-block;
  margin: 0.25em 0.25em 0 0;
  a {
    float: left;
    transition: 0.2s;
    background: ${props => props.theme.colors.background};
    padding: 0.5em;
    border-radius: 2px;
    text-transform: capitalize;
    text-decoration: none;
    color: ${props => props.theme.colors.text};
    border: 2px solid ${props => props.theme.colors.text};
    &:hover {
      background: ${props => props.theme.colors.green};
    }
  }
`

const TagList = props => {
  return (
    <List>
      {props.tags.map(tag => (
        <Tag key={tag.id}>
          <Link to={`${props.basePath}/tag/${tag.slug}/`}>{tag.title}</Link>
        </Tag>
      ))}
    </List>
  )
}

export default TagList
